// import http, {useLoginJwt, dontUseLoginJwt} from "services/httpService"
import axios from "axios";
import { toast } from "react-toastify";
import * as config from "config";
import * as userActions from "store/auth/user/actionTypes";
import { decryptPayload, encryptPayload } from "utils/encrypt_decrypt";



const api = store => next => async action => {



    const getBaseUrl = (baseUrl) => {
        let apiBaseUrl;
        if (typeof baseUrl !== "undefined") {
            // console.log("use custom", baseUrl);
            apiBaseUrl = baseUrl;
        }
        else {
            // console.log("use default", config.apiBaseUrl);
            apiBaseUrl = config.apiBaseUrl;
        }
        return apiBaseUrl;
    }



    const getToken = (customToken) => {
        let apiToken;
        if (typeof customToken !== "undefined") {
            // console.log("use custom", customToken);
            apiToken = customToken;
        }
        else {
            const loginJwt = store.getState().auth.userPersist.data.token;
            // console.log("use loginJwt", loginJwt);
            apiToken = loginJwt;
        }
        return apiToken;
    }



    const isUserTokenActive = () => {
        const tokenExpiryValue = store.getState().auth.userPersist.data.tokenExpiry;
        if (tokenExpiryValue !== undefined && tokenExpiryValue !== null){
            const tokenExpiryTime = (parseInt(tokenExpiryValue) * 1000);
            const currentTime = Date.now();
            
            if (currentTime > tokenExpiryTime){
                // console.log("jwt has expired");
                toast.error("Expired Session, Please Login Again", {
                    toastId: "expired",
                });
                setTimeout(() => {
                    store.dispatch({ type: userActions.LOGOUT_USER });
                    return false;
                }, 1000)
            }
            else{
                // console.log("jwt hasn't expired");
                return true;
            }
        }
        // console.log("user isn't loggedin yet");
        return true;
    }
    let encryptedUrls = [];
    const getEncryptedPayload = (data, url, useEncryption) => {
        let params = data;
        if (useEncryption && useEncryption === true){
            encryptedUrls.push(url);
            const encryptedData = encryptPayload(data);
            return encryptedData;
        }
        return params;
    }

    
    const getDecryptedResponse = (response) => {
        if (!response || !response.config) return {};
        const {config, data} = response;
        const endpointUrl = config.baseURL?.toString() + config.url?.toString();
        const endpointUrlIndex = encryptedUrls.indexOf(endpointUrl);
        if (endpointUrlIndex > -1 && data && data?.iv && data?.encryptedValue){
            encryptedUrls.splice(endpointUrlIndex, 1);
            const decryptedData = decryptPayload(data);
            return decryptedData ?? {};
        }
        else{
            return data;
        }
    }



    if (action.type !== config.apiRequestStart) {
        next(action);
    }
    else {
        if (isUserTokenActive() === true){


        const { baseUrl, url, method, data, onStart, onSuccess, onError, useLoginJwt, customToken, useEncryption } = action.payload;

        if (onStart) {
            store.dispatch({ type: onStart });
        }

        const apiBaseUrl = getBaseUrl(baseUrl);
        const params = getEncryptedPayload(data, (apiBaseUrl.toString() + url.toString()), useEncryption);

        let http;
        if ((typeof useLoginJwt !== "undefined") && (useLoginJwt === false)) {
            http = axios.create();
        }
        else {
            const token = getToken(customToken);
            http = axios.create({
                headers: {
                    Authorization: token,
                }
            });
        }


        next(action);                                                                           // for debugger logging purpose (in chrome Redux dev tools)


        await http.request({
            baseURL: apiBaseUrl,
            url,
            method,
            data: params,
        }).then((response) => {
            store.dispatch({ type: config.apiRequestSuccess, payload: response });                // for debugger logging purpose
            if (onSuccess) {
                const payload = getDecryptedResponse(response);
                if (payload?.error && payload?.message) {
                    toast.error(payload?.message);
                }
                store.dispatch({ type: onSuccess, payload });
            }
        }).catch((error) => {
            // console.log(error); //check with dummy base64 endpoint online
            store.dispatch({ type: config.apiRequestFailed, payload: error });                    // for debugger logging purpose
            if (onError) {
                if (error.response) {
                    const decryptedResponse = getDecryptedResponse(error.response);
                    store.dispatch({ type: onError, payload: decryptedResponse });
                    if (error.response.data.message === "Expired Session, Please Login Again") {
                        // window.setTimeout(function () {
                            store.dispatch({ type: userActions.LOGOUT_USER });
                        // }, 1000);
                    }
                }
                else if (error.request) {
                    if (navigator.onLine) {
                        store.dispatch({
                            type: onError,
                            payload: {
                                message: "Error: Invalid request. Please try again later."
                            }
                        });
                    }
                    else {
                        store.dispatch({
                            type: onError,
                            payload: {
                                message: "No Internet Connection"
                            }
                        });
                    }
                }
                else {
                    store.dispatch({
                        type: onError,
                        payload: {
                            message: "An error occurred. Please try again later."
                        }
                    });
                }
            }
        });

        
        }
    }

}

export default api;